import defaultState, { UIReducer } from './defaultState'
import * as actionTypes from '../../constants/actionTypes'
import { GigTypes } from '../../actions/gig/gigTypes'
import { roomTypes } from '../../actions/room/roomTypes'
import constants, { status } from '@bt-react/constants'
import { ReduxAction } from '../reducerType'
import { UIType } from '../../actions/ui/uiTypes'
import { DocsType } from '../../actions/docs/docsTypes'
import { TrackType } from '../../actions/tracks/trackTypes'

export default function (state: UIReducer = defaultState, { type, payload }: ReduxAction): UIReducer {

  const isUpcoming = payload === status.UPCOMING ||
        payload === status.RESCHEDULED ||
        payload === status.T_MINUS_30

  const isLiveReady = payload === status.LIVE_ENABLED

  const isLive = payload === status.LIVE ||
    payload === status.OVERRUN

  const isTerminated = payload === status.POST_ROLL_INTERSTITIAL ||
    payload === status.CANCELLED ||
    payload === status.COMPLETE

  const isLiveRequested = payload === status.GOING_LIVE

  const showLiveEnabledModal = payload === status.LIVE_ENABLED

  const newState = {
    ...state,
    status: payload,
    isUpcoming,
    isLiveReady,
    isLive,
    isTerminated,
    isLiveRequested,
    showLiveEnabledModal
  }

  switch (type) {

    case DocsType.SET_BOOKING_STATUS:

      switch (payload) {

        case status.LIVE_ENABLED:
          return {
            ...newState,
            showInterstitial: false,
            liveDateTime: null,
            isEndRequested: false
          }
        case status.LIVE:
        case status.OVERRUN:
          return {
            ...newState,
            showInterstitial: false,
            isEndRequested: false
          }
        case status.GOING_LIVE:
          return {
            ...newState,
            showInterstitial: false,
            liveDateTime: null
          }
        case status.COMPLETE:
          return {
            ...newState,
            showInterstitial: false,
            liveDateTime: null
          }
        case status.PRE_ROLL_INTERSTITIAL:
          return { ...newState, showInterstitial: true }
        case status.POST_ROLL_INTERSTITIAL:
          return { ...newState, showInterstitial: true }
        default:
          return newState

      }
    case GigTypes.SET_GOING_LIVE:
      return { ...state, isLiveRequested: true, goingLive: true }
    case GigTypes.UNSET_GOING_LIVE:
      return { ...state, isLiveRequested: false, goingLive: false }
    case GigTypes.SET_ENDING_LIVE:
      return { ...state, isLiveRequested: false, isEndRequested: true }
    case GigTypes.SET_ENDING_LIVE_SUCCESS:
      return { ...state, isLive: false, showInterstitial: true }
    case GigTypes.UNSET_ENDING_LIVE:
      return { ...state, isEndRequested: false }
    case GigTypes.ENDING_LIVE_CONFIRMED:
      return { ...state, isLiveRequested: false, isLive: false, isEndRequested: false, isTerminated: true }
    case TrackType.FORCE_LOCAL_MUTE:
      return { ...state, forcedLocalMute: true }
    case TrackType.FORCE_LOCAL_MUTE_DISABLE:
      return { ...state, forcedLocalMute: false }
    case roomTypes.PARTICIPANT_MUTED:
    {

      if (state.isMuted.has(payload)) return state

      const isMuted = new Map(state.isMuted)
      isMuted.set(payload, true)

      return { ...state, isMuted }

    }
    case roomTypes.PARTICIPANT_UNMUTED:
    {

      if (!state.isMuted.has(payload)) return state

      const isMuted = new Map(state.isMuted)
      isMuted.delete(payload)

      return { ...state, isMuted }

    }
    case roomTypes.PARTICIPANT_CAM_HIDDEN:
    {

      if (state.isCamHidden.has(payload)) return state

      const isCamHidden = new Map(state.isCamHidden)
      isCamHidden.set(payload, true)

      return { ...state, isCamHidden }

    }
    case roomTypes.PARTICIPANT_CAM_VISIBLE:
    {

      if (!state.isCamHidden.has(payload)) return state

      const isCamHidden = new Map(state.isCamHidden)
      isCamHidden.delete(payload)

      return { ...state, isCamHidden }

    }
    case UIType.OPEN_SIDE_PANEL:
      return { ...state, isSidePanelOpen: true }
    case UIType.CLOSE_SIDE_PANEL:
      return { ...state, isSidePanelOpen: false }
    case UIType.SET_SELECTED_MENU_ITEM:
      return { ...state, menuItemSelected: payload, isSidePanelOpen: payload !== null }
    case UIType.TOGGLE_MODAL:
    {

      if (typeof payload !== 'undefined') return { ...state, isModalOpen: payload }

      return { ...state, isModalOpen: !state.isModalOpen }

    }
    case UIType.SHOW_SETTINGS_MODAL:
      return { ...state, showSettingsModal: true, settingsModalTab: payload || null }
    case UIType.HIDE_SETTINGS_MODAL:
      return { ...state, showSettingsModal: false }
    case UIType.SHOW_RESCHEDULED_MODAL:
      return { ...state, showRescheduledModal: true }
    case UIType.HIDE_RESCHEDULED_MODAL:
      return { ...state, showRescheduledModal: false }
    case UIType.OPEN_GIG_START_CONFIRMATION_MODAL:
      return { ...state, showGigStartConfirmationModal: true }
    case UIType.CLOSE_GIG_START_CONFIRMATION_MODAL:
      return { ...state, showGigStartConfirmationModal: false }
    case UIType.OPEN_GIG_END_CONFIRMATION_MODAL:
      return { ...state, showGigEndConfirmationModal: true }
    case UIType.CLOSE_GIG_END_CONFIRMATION_MODAL:
      return { ...state, showGigEndConfirmationModal: false }
    case UIType.SHOW_STREAM_MODAL:
      return { ...state, showStreamModal: true }
    case UIType.HIDE_STREAM_MODAL:
      return { ...state, showStreamModal: false }
    case GigTypes.SET_LIVE_TIME:
      return { ...state, liveDateTime: payload }
    case DocsType.RESET_SESSION:
      return { ...defaultState }
    case roomTypes.SET_MESSAGE_CODE:
      return { ...state, messageCode: payload }
    case GigTypes.EXTEND_GIG_TERMINATION_SUCCESS:
    case GigTypes.TERMINATE_GIG:
      return { ...state, isDeadMansHandleOpen: false }
    case UIType.SHOW_DEAD_MANS_HANDLE:
      return { ...state, isDeadMansHandleOpen: true }
    case actionTypes.HIDE_ITS_TIME:
      return { ...state, hideItsTime: true }
    case roomTypes.TWILIO_RECONNECTING:
      return { ...state, twilioConnectionError: new Date().toISOString() }
    case roomTypes.TWILIO_RECONNECTED:
      return { ...state, twilioConnectionError: null }
    case UIType.CLOSE_PLAY_IN_MEDIA_DRAWER:
      return { ...state, selectedDrawer: null }
    case UIType.OPEN_PLAY_IN_MEDIA_DRAWER:
      return { ...state, selectedDrawer: constants.drawerType.PLAY_IN }
    case UIType.CLOSE_SLIDES_MEDIA_DRAWER:
      return { ...state, selectedDrawer: null }
    case UIType.OPEN_SLIDES_MEDIA_DRAWER:
      return { ...state, selectedDrawer: constants.drawerType.SLIDES }
    case UIType.CLOSE_SPOTLIGHT_MEDIA_DRAWER:
      return { ...state, selectedDrawer: null }
    case UIType.OPEN_SPOTLIGHT_MEDIA_DRAWER:
      return { ...state, selectedDrawer: constants.drawerType.SPOTLIGHT }
    case UIType.TOGGLE_MEDIA_DRAWER:
      return { ...state, showMediaDrawer: !state.showMediaDrawer }
    case UIType.SHOW_PLAY_IN_MODAL:
      return { ...state, showPlayInModal: true }
    case UIType.HIDE_PLAY_IN_MODAL:
      return { ...state, showPlayInModal: false }
    case UIType.SHOW_SLIDES_UPLOAD_MODAL:
      return { ...state, showSlidesUploadModal: true }
    case UIType.HIDE_SLIDES_UPLOAD_MODAL:
      return { ...state, showSlidesUploadModal: false }
    case UIType.WINDOW_BLUR:
      return { ...state, focused: false}
    case UIType.WINDOW_FOCUS:
      return { ...state, focused: true}
    default:
      return state

  }

}
